export default {
    startPage: {
        title: 'Apprentissage de Vue'
    },
    menu: {
        Documents: 'Dossier sportif',
        Setting: 'Paramètres système',
        Applications: "Système de test",
        Report: "Rapport d'analyse",
        AthleteDocuments: "Sportif",
        SportProject: "Discipline sportive",
        Options: "Paramètres de base",
        Permission: "Gestion des autorisations",
        StandardData: "Gestion des valeurs standard",
        MuscleStrengthStandard: "Valeurs de référence de force musculaire portable",
        UserManagement: "Gestion du personnel",
        Subject: "Détails du sportif",
        Record: "Enregistrements personnels",
        Result: "Résultats des tests",
        Actions: "Données des mouvements",
        SportsPerformanceStandardData: "Système de performance fonctionnelle sportive",
        MuscleStrengthStandardData: "Système de test de force musculaire portable",
    },
    userMenu: {
        confirmExit: "Déconnexion",
        confirmMsg: "Confirmer la déconnexion ?",
        DarkMode: "Mode sombre",
        Modify: "Modifier le profil",
        Account: "Compte",
        UserName: "Nom d'utilisateur",
    },
    options: {
        Title: "Préférences",
        Language: "Langue",
        ModifyNotice: "Modification réussie",
        ModifyNotice2: "Modification échouée",
        SystemSettings: "Paramètres de base",
        AccountSetting: "Paramètres du compte",
        Account: "Compte",
        OrganizationInfo: "Informations de l'organisation",
        CompanyName: "Nom de l'entreprise :",
        CompanyCode: "Code de l'entreprise :",
        CustomLogo: "Logo personnalisé",
        Name: "Nom",
        Preview: "Aperçu",
        UploadPictures: "Cliquer pour télécharger des images",
        Notice1: "Taille optimale de l'image : hauteur 48px, largeur jusqu'à 200px, moins de 1Mo, format PNG ou JPG",
        ModifyPassword: "Réinitialiser/Modifier le mot de passe",
        confirmExit: "Déconnexion",
        ModifyName: "Modifier le nom",
        notice2: "Modification du nom réussie",
        notice3: "Veuillez saisir votre nom",
        Lable: {
            Multilingual: "Multilingue",
            Logo: "Logo personnalisé",
        }
    },
    login: {
        Label: {
            UserName: "Compte",
            Password: "Mot de passe",
            Login: "Connexion",
            Reset: "Réinitialiser",
            Title: "Veuillez vous connecter",
            Title2: "Inscription",
            Forget: "Mot de passe oublié?",
            Remember: "Se souvenir du mot de passe",
            Register: "Aller à l'inscription >>",
            ToLogin: "Vous avez déjà un compte ? Connectez-vous >>",
            Captche: "Récupérer le code",
            Retry: "Réessayer",
            Agree: "Accepter les Conditions d'utilisation",
            UserNamePlaceholde: "Veuillez saisir votre nom d'utilisateur",
            PasswordPlaceholde: "Veuillez saisir votre mot de passe",
            CompanyCodePlaceholder: "Code de l'entreprise",
            MailBoxPlaceHolder: "Veuillez saisir votre adresse e-mail",
            CaptchaPlaceholder: "Code e-mail",
        },
        Message: {
            PasswordLength: "La longueur du mot de passe doit être comprise entre 8 et 16 caractères",
            CaptchaSuccess: "Envoi réussi",
            Agree: "Veuillez lire et cocher les Conditions d'utilisation",
            AccountEmpty: "Veuillez remplir correctement votre adresse e-mail",
            Registered: "Inscription réussie",
            loginFaild: "Échec de la connexion",
            Captcha: "La longueur du code de vérification est insuffisante",
            CaptchaLenthL: "Veuillez saisir le code de vérification complet",
            CompanyCodeLength: "Veuillez saisir correctement le code de l'entreprise",
        }
    },
    forget: {
        Label: {
            Title: "Récupérer le mot de passe",
            GoToLogin: "Aller à la connexion >>",
            Captche: "Récupérer le code",
            Reset: "Réinitialiser le mot de passe",
            Retry: "Réessayer",
            Contact: "Si cette page ne résout pas votre problème, contactez le service client",
            AccountPlaceholder: "Veuillez saisir votre adresse e-mail de connexion",
            CaptchaPlaceholder: "Code e-mail",
            PasswordPlaceholder: "Nouveau mot de passe",
            ModifyPassword: "Modifier le mot de passe",
        },
        Message: {
            CaptchaSuccess: "Envoi réussi",
            ResetSuccess: "Réinitialisation réussie",
            AccountEmpty: "Veuillez remplir correctement votre adresse e-mail",
        }
    },
    global: {
        HomePage: "Accueil",
        Loading: "Chargement",
        CopySuccess: "Copie réussie",
        CopyFailed: "Copie échouée",
        Refresh: "Actualiser",
        Add: "Ajouter",
        Create: "Créer",
        Modify: "Modifier",
        Confirm: "Confirmer",
        Cancel: "Annuler",
        Save: "Enregistrer",
        View: "Afficher",
        Edit: "Éditer",
        Delete: "Supprimer",
        Finish: "Terminer",
        LastWeek: "Dernière semaine",
        LastMonth: "Dernier mois",
        Last3Month: "Trois derniers mois",
        StartDate: "Date de début",
        EndDate: "Date de fin",
        TestProject: "Projet de test",
        SportProject: "Discipline sportive",
        None: "Illimité",
        Gender: "Sexe",
        RequestFailed: "Échec de l'envoi de la requête !",
        ResponseFailed: "Échec de la réponse de la requête !",
        LoadSuccess: "Téléchargement réussi",
        LoadFailed: "Échec du téléchargement",
        EditRelation: "Éditer la relation sportive",
        EditSubject: "Éditer les informations du sportif",
        EditProject: "Éditer la discipline sportive",
        Import: "Importer",
        Export: "Exporter",
        NoneData: "Aucune donnée disponible",
        NoneRank: "Aucun classement disponible",
        SaveSuccess: "Enregistrement réussi",
        Checked: "Coché",
        Close: "Fermer",
    },
    Permission: {
        Label: {
            Title: "Gestion des autorisations",
            Enable: "Activer",
            Description: "Description",
            ExpireDate: "Date d'expiration",
            CreateGroup: "Créer un groupe",
            GroupRole: "Type de rôle",
            GroupName: "Nom du rôle",
            SelectRoleType: "Sélectionner le type de rôle",
        },
        Message: {
            GetGroupsFailed: "Échec de l'obtention des groupes",
            GetApplicationListFailed: "Échec de l'obtention de la liste des applications",
            ChangeUnsaved: "Modifications non enregistrées, confirmez-vous vouloir quitter ?",
            ComfirmToDelete: "Confirmez-vous vouloir supprimer ce groupe ?",
            DeleteSuccess: "Suppression réussie",
        }
    },
    Documents: {
        Lable: {
            ViewPersonDocument: "Afficher le dossier personnel",
            InvationInfo: "Informations sur l'invitation à l'inscription",
            DeleteInvation: "Supprimer l'invitation",
            ViewHistoryRecords: "Afficher l'historique des enregistrements",
            ViewDetailRecords: "Afficher les détails des enregistrements",
            TestDetialExport: "Exporter les détails des enregistrements",
            ViewActionDetail: "Afficher les détails des mouvements",
            ActionDataExport: "Exporter les données des mouvements",
        },
        HomePage: "Accueil",
        Reinvite: "Réinviter",
        SportDocuments: "Dossiers sportifs",
        RegisterSubject: {
            Title: "Nous vous invitons à compléter vos informations",
            Save: "Soumettre les informations",
            From: "De la part de",
            Invitation: "l'invitation",
            PlaseEnter: "Veuillez saisir",
        },
        Athletes: {
            TotalCount: "Actuellement au total",
            TotalProjects: "projets",
            DeleteNotice: "Êtes-vous sûr de vouloir supprimer le sportif en cours d'invitation à remplir les informations ?",
            ProjectNameSearch: "Prend en charge la recherche par nom de discipline sportive",
            selectDate: "Sélectionner la date",
            CreateTime: "Date de création",
            ClickShow: "Cliquer pour déplier",
            ClickPutaway: "Cliquer pour replier",
            FormarErrorNotice: "(Remarque : au plus une décimale est conservée)",
            EmailNoticeLogin: "Adresse e-mail (utilisable pour la connexion)",
            LoginEmail: "Utilisable pour la connexion",
            Athletes: "Sportifs",
            MultipleSelection: "Sélection multiple",
            true: "Sélection multiple",
            false: "Terminé",
            AddDocuments: "Ajouter des dossiers",
            TestSystem: "Système de test (radio)",
            Nodata: "Aucune donnée disponible",
            SportFunction: "Système de test de performance fonctionnelle sportive",
            DigitalRunway: "Logiciel d'acquisition et d'analyse de données de piste numérique",
            MuscleStrength: "Système de test de force musculaire",
            GolfTechnique: "Diagnostic de technique de golf",
            Screening: "Filtrage",
            GenderLimit: "Illimité par sexe",
            SystemLimit: "Illimité par système",
            TestProject: "Projet de test",
            Photo: "Photo",
            NextPage: "Page suivante",
            PreviousPage: "Page précédente",
            Age: "Âge",
            View: "Afficher",
            EditingData: "Modifier les informations",
            HistoricalRecord: "Historique des enregistrements",
            SkipPages: "Passer aux pages",
            AddTestProject: "+ Ajouter au projet de test",
            AssociationSportProject: "+ Associer un projet sportif",
            DeldeteDocument: "Supprimer le dossier",
            Complete: "Terminé",
            SearchNotice: "Prend en charge la recherche par nom",
            CreateSubject: "Ajouter un dossier",
            ModifySubject: "Modifier le dossier",
            AddRelationSuccessNotice: "Ajout de la relation réussi",
            AddRelationFailNotice: "Échec de l'ajout de la relation",
            AddRelationNotice: "Veuillez sélectionner le projet à associer",
            BaseInfo: "Informations de base",
            InviteUsersRegister: "Inviter les utilisateurs à s'inscrire",
            Save: "Enregistrer",
            Total: "Au total",
            Projects: "projets au total",
            Picture: "Photo",
            PhotoLimitNotice: "Photos limitées à 1M",
            PhotoLimitNotice2: "Veuillez télécharger une photo de taille inférieure à 1M",
            Name: "Nom",
            EnterNotice: "Veuillez saisir le nom du sportif",
            Gneder: "Sexe",
            Birthday: "Date de naissance",
            Height: "Taille",
            Weight: "Poids",
            EnterWeightNotice: "Veuillez saisir le poids du sportif",
            EnterHeightNotice: "Veuillez saisir la taille du sportif",
            PhoneNumber: "Numéro de téléphone",
            EnterPhoneNumberNotice: "Veuillez saisir le numéro de téléphone",
            RequiredNotice: "Ne peut pas être vide",
            PhoneNumberNotice: "Veuillez saisir un format de numéro correct",
            Email: "Adresse e-mail",
            EnterEmailNotice: "Veuillez saisir l'adresse e-mail",
            EmailNotice: "Veuillez saisir un format d'adresse e-mail correct",
            PictureFileNotice: "Veuillez sélectionner un fichier image correct",
            PictureSizeNotice: "La taille de l'image doit être inférieure à 1M",
            Manage: "Gérer",
            Add: "+ Ajouter",
            Years: "ans",
            FormarError: "Format de données incorrect",
            ViewDocument: "Afficher le dossier",
            AddToProject: "Ajouter au projet",
            Record: "Enregistrement",
            LoadAll: "Toutes les ressources ont été chargées",
            Reset: "Réinitialiser",
            Invationing: "Enregistrements d'invitation",
            BatchExportIndicator: "Indicateur d'exportation en masse",
            BatchExportRawData:'Exporter les données brutes par lot',
            Link: {
                Invitation: "Inviter les utilisateurs à s'inscrire",
                FileName: "Nom du dossier",
                LoginEmail: "Courriel d'inscription",
                InvitationLink: "Lien d'invitation",
                SendInvitation: "Envoyer l'invitation",
                CopyLink: "Copier le lien",
                LinkNotice: "Les utilisateurs doivent soumettre leurs informations pour compléter la création du dossier",
                InvitationOther: "Inviter d'autres personnes",
                Notice: "Copie réussie",
                Notice2: "Copie échouée",
                Notice3: "Invitation envoyée avec succès",
                Notice4: "Échec de l'envoi de l'invitation",
                InvationNotice: "Après avoir saisi le nom du sportif et cliqué pour générer le lien, le lien d'invitation sera envoyé directement à l'adresse e-mail renseignée",
                Notice5: "Veuillez saisir le nom du sportif",
            },
            Details: {
                RelationToProject: "Ajouter au projet",
                ModifySocument: "Modifier les informations",
                RelationRecord: "Enregistrements associés",
                None: "Aucun",
                SwingSide: "Joueur de frappe",
                PowerLeg: "Jambe de propulsion",
                LeftHand: "Main gauche",
                RightHand: "Main droite",
                LeftLeg: "Jambe gauche",
                RightLeg: "Jambe droite",
                Left: "Gauche",
                Right: "Droite",
                LeftRight: "Gauche et droite",
                ShoeSize: "Taille de chaussure",
                Statistics: "Statistiques des données",
                ClickNotice: "Cliquer sur une action ou un nombre pour afficher les détails",
                Unit: {
                    SwingSide: "Main",
                    PowerLeg: "Jambe",
                    ShoeSize: "Pointure",
                }
            },
            TestRecord: {
                TestRecord: "Enregistrements de test",
                StartDate: "Date de début",
                EndDate: "Date de fin",
                SelectNotice: "Veuillez d'abord sélectionner le système de test",
                Time: "Temps",
                None: "Aucun",
                DataLength: "enregistrements",
            },
            Result: {
                Application8: {
                    "Swing": "Bascule des bras",
                    "Akimbo": "Mains sur les hanches",
                    "Other": "Autre",
                    "Bilateral": "Bilatéral",
                    "Left": "Gauche",
                    "Right": "Droite",
                    "MidThighPull": "Soulevé de terre mi-cuisse",
                    "1_4Squat": "Squat 1/4",
                    "CalfRaise": "Soulevé de talons",
                    "Customization": "Personnalisation",
                    "ITest": "Test I",
                    "YTest": "Test Y",
                    "TTest": "Test T",
                    "FreeMode": "Mode libre",
                    "TimekeepingMode": "Mode chronométré",
                    "UpperLimbs": "Membres supérieurs",
                    "LowerLimbs": "Membres inférieurs",
                    "力": "Force",
                    "时间": "Temps",
                    "速度/加速度": "Vitesse/Accélération",
                    "功率": "Puissance",
                    "位移": "Déplacement",
                    "其他": "Autre",
                    "冲量": "Impulsion",
                    "频率": "Fréquence",
                    "Remark": "Remarque",
                    '': '',
                    'ImportantLeftRightRatio': 'Composantes clés latérales (gauche/droite)',
                    'OtherLeftRightRatio': 'Autres composantes latérales (gauche/droite)',
                    'ArmWeight': 'Poids du bras'
                },
                SendNotice: "Veuillez sélectionner le contenu à envoyer",
                SendSuccessfully: "Envoi réussi",
                EmailContent: "Contenu de l'e-mail",
                SendEmail: "Envoyer l'e-mail",
                ReceivingEmail: "Courriel de réception",
                COPPosition: "COP",
                ModelSetting: "Configuration du module",
                ModelType: "Module de test",
                L_Fz_COP: "Ligne de connexion L-COP",
                R_Fz_COP: "Ligne de connexion R-COP",
                Fz_COP: "Ligne de connexion Force-COP",
                Left: "Gauche",
                Right: "Droite",
                Fz: "Force",
                COP: "Vue COP",
                AllFz: "Force-Fz",
                Legend: "Légende",
                Asi: "Indice d'asymétrie",
                LeftRightRatio: "Ratio gauche-droit",
                HistoryMax: "Maximum historique",
                Now: "Actuel",
                MainIndicators: "Indicateurs principaux",
                OtherIndicators: "Plus d'indicateurs",
                ExtendedIndicators: "Indicateurs étendus",
                SingleView: "Indicateurs uniques",
                NumberOfTimes: "Nombre de fois",
                NoData: "Données non enregistrées",
                GoBack: "Retour",
                RawData: "Télécharger les enregistrements bruts",
                Export: "Exporter les indicateurs",
                Weight: "Poids de test",
                Duration: "Durée du test",
                GolfClubs: "Clubs de golf utilisés",
                Spacing: "Distance entre les pieds",
                LeftAngle: "Angle de déviation gauche",
                RightAngle: "Angle de déviation droite",
                LeftLeg: "Jambe gauche",
                RightLeg: "Jambe droite",
                ResultantForce: "Force résultante",
                Limbs: "Tronc",
                Side: "Partie",
                Actions: "Actions",
                Pose: "Posture",
                Order: "Ordre",
                Joint: "Articulation",
                KneePosition: "Position du genou",
                Times_L: "Nombre de pas gauche",
                Times_R: "Nombre de pas droit",
                0: "Défaut",
                1: "Gauche",
                2: "Droite",
                3: "Gauche puis droite",
                4: "Droite puis gauche",
                Unit: {
                    KneePosition: 'CM',
                    Times_L: '',
                    Times_R: '',
                    Spacing: 'CM',
                    Weight: 'KG',
                    Duration: 'S',
                    LeftAngle: '°',
                    RightAngle: '°'
                },
                OnceHeader: "Tème fois",
                ExportReport: "Exporter le rapport",
                Repetitions: "Nombre de répétitions",
                ContainsPersonalRecords: "Contient des enregistrements personnels",
                MuscleStrengthAvgIndicator: {
                    "最大峰值力": "Force de pic maximale",
                    "平均峰值力": "Force de pic moyenne",
                    "到达峰值时间": "Temps pour atteindre le pic",
                    "峰值发力率": "Taux de développement de force au pic",
                    "峰值力": "Force de pic",
                },
                "左侧最大范围": "Plage maximale gauche",
                "左侧最大范围时间": "Temps de la plage maximale gauche",
                "右侧最大范围": "Plage maximale droite",
                "右侧最大范围时间": "Temps de la plage maximale droite",
                "左侧平均范围": "Plage moyenne gauche",
                "最大范围BSA": "Plage maximale BSA",
                "右侧平均范围": "Plage moyenne droite",
                "最大范围": "Plage maximale",
                "平均范围": "Plage moyenne",
                "最大范围时间": "Temps de la plage maximale",
                Times: "Nombre de fois",
                NumberOfTests: "Nombre de tests",
                LeftSide: "Gauche",
                RightSide: "Droite",
                "数值": "Valeur",
                ReferenceValue: "Valeur de référence",
                Internal: "Rotation interne",
                External: "Rotation externe",
                Adduction: "Adduction",
                Abduction: "Abduction",
                Varus: "Varus",
                Valgus: "Valgus",
                MaximumForceRatio: "Rapport de force maximale",
                AvgForce: "Force de pic moyenne",
                MaxForce: "Force de pic maximale",
                MaxImpulse: "Impulsion maximale",
                AvgImpulse: "Impulsion moyenne",
                AvgForce_Baseline: "Force de pic moyenne (valeur de base)",
                MaxForce_Baseline: "Force de pic maximale (valeur de base)",
                MaxImpulse_Baseline: "Impulsion maximale (valeur de base)",
                AvgImpulse_Baseline: "Impulsion moyenne (valeur de base)",
            },
            Action: {
                Action: "Données des mouvements",
                TrendChart: "Graphique de tendance",
                IndexNotice: "Veuillez sélectionner les indicateurs à afficher",
                RelationRecord: "Enregistrements associés",
                Delete: "Supprimer",
                Export: "Exporter les enregistrements sélectionnés",
                None: "Aucun",
                ExportData: "Exporter les données brutes",
                ExportData1: "Exporter les données",
                EcportIndex: "Exporter les indicateurs",
                ExportReport: "Exporter le rapport",
                C3DReport: "Exporter le C3D",
                ViewRecord: "Afficher les enregistrements",
                Index: "Indicateurs",
                Report: "Rapport",
                Data: "Données brutes",
                Total: "Au total",
                Datas: "données",
                Max: "Maximum",
                Min: "Minimum",
                Notice: "Veuillez d'abord sélectionner les enregistrements",
                NoIndex: "Aucun indicateur",
            },
            SingleCreate: "Ajouter manuellement",
            DownloadTemplate: "Télécharger le modèle d'importation",
            SubjectImportTemplate: "Modèle d'import de sujets",
            ImportFromTemplate: "Importer en masse via le modèle",
            Template: "Modèle d'importation en masse d'athlètes",
            Upload: "Importer",
            ImportSuccess: "Importation réussie",
            ImportFailed: "Échec de l'importation",
            Items: "Éléments",
        },
        SportProjects: {
            SportProjects: "Disciplines sportives",
            AddSportProjectNotice: "Les disciplines sportives sont uniquement utilisées pour distinguer les athlètes",
            ProjectName: "Nom de la discipline sportive",
            AddProject: "Ajouter une discipline sportive",
            RelatedCount: "Nombre de personnes associées",
            Operate: "Opération",
            RelatedAthletes: "Athlètes associés",
            AddSportProject: "Ajouter une discipline sportive",
            notice1: "Sélectionnez au moins un",
            SelectApplications: "Systèmes d'application",
            ProNameNotice: "Entrez le nom de la discipline sportive",
            addSuccessNotice: "Ajout de la discipline sportive réussi",
            addFaildNotice: "Échec de l'ajout de la discipline sportive",
            deleteSuccessNotice: "Suppression de la discipline sportive réussie",
            deleteFaildNotice: "Échec de la suppression de la discipline sportive",
            updateSuccessNotice: "Modification de la discipline sportive réussie",
            updateFaildNotice: "Échec de la modification de la discipline sportive",
            CreateSportProject: "Créer une discipline sportive",
            EmptyNotice: "Veuillez saisir le nom de la discipline sportive",
            People: "personnes",
            Name: "Nom",
            Gender: "Sexe",
            Birthday: "Date de naissance",
            ModifyName: "Modifier",
            ModifySportProject: "Modifier la discipline sportive",
            modifySuccessNotice: "Modification du nom de la discipline sportive réussie",
            modifyFaildNotice: "Le nom de la discipline sportive ne peut pas être dupliqué",
            AddSport: "Gérer les athlètes",
            Athletes: "Athlètes",
            QueryError: "Erreur de requête",
            Added: "Déjà ajouté",
            SaveFailNotice: "Échec de la sauvegarde",
            SaveSuccessNotice: "Sauvegarde réussie",
            NotSaved: "Le contenu n'a pas été sauvegardé. Voulez-vous quitter ?",
            DeleteNotice: "Êtes-vous sûr de vouloir supprimer cette discipline sportive ?",
            Notice: "Remarque",
            DeleteProjcctNotice: "Supprimer la discipline sportive",
        }
    },
    Application: {
        Name: {
            1: "Système de test de force musculaire",
            5: "Système de diagnostic de technique de golf",
            6: "Système de test des ischio-jambiers",
            7: "Support de mesure multi-fonctions",
            8: "Système de test de performance fonctionnelle sportive",
            9: "Amplitude articulaire",
        },
        Label: {
            Detail: "Afficher les détails",
            SubjectCount: "Nombre de sportifs",
            RecordCount: "Nombre d'enregistrements de test",
            ProjectCount: "Nombre de projets de test",
            RankList: "Affichage du classement",
            More: "Plus >",
            TrendCharts: "Tendance des tests",
            Indicators: "Indicateurs",
            ExportIndicators: "Exporter les indicateurs",
            TrainingPlan: "Plan d'entraînement",
            MostRecentRecord: "Dernier enregistrement",
            AllRecords: "Tous les enregistrements",
        },
        Options: {
            LastDays: "Derniers %d jours",
        },
        Columns: {
            CreateTime: "Date de création",
        },
    },
    Report: {
        Label: {
            MinAvgMax: "Minimum/Maximum",
            ReportChart: "Graphique du rapport de données",
            Query: "Filtrer",
            Export: "Exporter",
            IndicatorOptions: "Filtrage des indicateurs",
            SubjectOptions: "Sélectionner les sportifs",
            MaxValue: "Max",
            MinValue: "Min",
            InsertChart: "Ajouter un graphique",
            ModifyChart: "Modifier le graphique",
            true: "Prendre la valeur maximale",
            false: "Prendre la valeur minimale",
            指标: 'Indicateur',
            值: 'Valeur',
            单位: 'Unité'
        },
        Message: {
            IndicatorsEmpty: "Veuillez sélectionner un indicateur",
            SubjectEmpty: "Veuillez sélectionner un sportif",
        },
        Indicators: {
            "峰值": "Pic",
            "峰值时间": "Temps de pic",
            "最大发力率": "Taux de développement de force maximal",
            "最大峰值力": "Force de pic maximale",
            "平均峰值力": "Force de pic moyenne",
            "到达峰值时间": "Temps pour atteindre le pic",
            "峰值发力率": "Taux de développement de force au pic",
            "左脚平均峰值力": "Force de pic moyenne du pied gauche",
            "右脚平均峰值力": "Force de pic moyenne du pied droit",
            "左脚最大力值": "Force maximale du pied gauche",
            "右脚最大力值": "Force maximale du pied droit",
            "左脚重复次数": "Nombre de répétitions du pied gauche",
            "右脚重复次数": "Nombre de répétitions du pied droit",
            "左重复次数": "Nombre de répétitions gauche",
            "右重复次数": "Nombre de répétitions droite",
            "内收左重复次数": "Nombre de répétitions d'adduction gauche",
            "内收右重复次数": "Nombre de répétitions d'adduction droite",
            "外展左重复次数": "Nombre de répétitions d'abduction gauche",
            "外展右重复次数": "Nombre de répétitions d'abduction droite",
            "内旋左重复次数": "Nombre de répétitions de rotation interne gauche",
            "内旋右重复次数": "Nombre de répétitions de rotation interne droite",
            "外旋左重复次数": "Nombre de répétitions de rotation externe gauche",
            "外旋右重复次数": "Nombre de répétitions de rotation externe droite",
            "内翻左重复次数": "Nombre de répétitions de varus gauche",
            "内翻右重复次数": "Nombre de répétitions de varus droite",
            "外翻左重复次数": "Nombre de répétitions de valgus gauche",
            "外翻右重复次数": "Nombre de répétitions de valgus droite",
            "左最大力值": "Force maximale gauche",
            "右最大力值": "Force maximale droite",
            "内收左最大力值": "Force maximale d'adduction gauche",
            "内收右最大力值": "Force maximale d'adduction droite",
            "外展左最大力值": "Force maximale d'abduction gauche",
            "外展右最大力值": "Force maximale d'abduction droite",
            "内旋左最大力值": "Force maximale de rotation interne gauche",
            "内旋右最大力值": "Force maximale de rotation interne droite",
            "外旋左最大力值": "Force maximale de rotation externe gauche",
            "外旋右最大力值": "Force maximale de rotation externe droite",
            "内翻左最大力值": "Force maximale de varus gauche",
            "内翻右最大力值": "Force maximale de varus droite",
            "外翻左最大力值": "Force maximale de valgus gauche",
            "外翻右最大力值": "Force maximale de valgus droite",
            "左脚扭矩": "Couple du pied gauche",
            "右脚扭矩": "Couple du pied droit",
            "左脚峰值力最大值": "Force de pic maximale du pied gauche",
            "右脚峰值力最大值": "Force de pic maximale du pied droit",
            "峰值力最大值BSA": "Force de pic maximale BSA",
            "左脚峰值力平均值": "Force de pic moyenne du pied gauche",
            "右脚峰值力平均值": "Force de pic moyenne du pied droit",
            "峰值力平均值BSA": "Force de pic moyenne BSA",
            "左脚冲量平均值": "Impulsion moyenne du pied gauche",
            "右脚冲量平均值": "Impulsion moyenne du pied droit",
            "冲量平均值BSA": "Impulsion moyenne BSA",
            "左脚冲量最大值": "Impulsion maximale du pied gauche",
            "右脚冲量最大值": "Impulsion maximale du pied droit",
            "冲量最大值BSA": "Impulsion maximale BSA",


            'Absolute': 'Valeur absolue',
            'Relative': 'Valeur relative',
            'LeftComponent': 'gauche',
            'RightComponent': 'droite',
            '缓冲最小力值': 'Force minimale de décharge',
            '制动最大力值': 'Force freinage maximale',
            '蹬伸最大力值': 'Force propulsive maximale',
            '落地最大力值': 'Force d’atterrissage maximale',
            '离心制动阶段发力率': 'Taux de développement de la force en freinage (RFD)',
            '制动最大力值发力率': 'Taux de développement de la force en propulsion (RFD)',
            '蹬伸平均功率': 'Puissance propulsive moyenne',
            '蹬伸峰值功率': 'Puissance propulsive maximale',
            '离心制动阶段冲量': 'Impulsion de freinage',
            '向心阶段净冲量': 'Impulsion concentrique',
            '下蹲时间': 'Durée excentrique',
            '制动时间': 'Durée de freinage',
            '蹬伸时间': 'Durée de propulsion',
            '蹬伸与制动时间比': 'Rapport durée propulsion/freinage',
            '峰值功率发生时刻': 'Temps jusqu’à la puissance maximale',
            '触地时间': 'Temps jusqu’au décollage',
            '腾空时间': 'Temps de vol',
            '落地稳定时间': 'Temps de stabilisation',
            '下蹲平均速度': 'Vitesse excentrique moyenne',
            '离心阶段峰值速度': 'Vitesse excentrique maximale',
            '向心阶段最大速度': 'Vitesse concentrique maximale',
            '峰值功率发生时速度': 'Vitesse à la puissance maximale',
            '起跳速度': 'Vitesse de décollage',
            '腾空高度Hv': 'Hauteur de saut (v)',
            '腾空高度': 'Hauteur de saut',
            '腾空高度Ht': 'Hauteur de saut (t)',
            '腾空高度HFt': 'Hauteur de saut (ft)',
            '下蹲深度': 'Profondeur d’abaissement',
            '反应力量指数RSI': 'RSI',
            '反应力量指数RSImod': 'RSI modifié',
            '动态力量指数DSI': 'DSI',
            '左侧动态力量指数DSI': 'DSI (gauche)',
            '右侧动态力量指数DSI': 'DSI (droite)',
            '离心利用率EUR': 'EUR',
            '预拉伸增强百分比PSAP': 'PSAP',
            '弹性指数ESI': 'ESI',
            '落地表现指数': 'Indice de performance à la réception',
            '最大蹬伸力发力率': 'Taux maximal de développement de la force (RFD)',
            '跌落峰值力': 'Force de freinage maximale',
            '左侧跌落峰值力': 'Force de freinage maximale (gauche)',
            '右侧跌落峰值力': 'Force de freinage maximale (droite)',
            '蹬伸峰值力': 'Force propulsive maximale',
            '跌落峰值力加载率': 'Taux de développement de la force en freinage (RFD)',
            '左侧跌落峰值力加载率': 'Taux de développement de la force en freinage (gauche)',
            '右侧跌落峰值力加载率': 'Taux de développement de la force en freinage (droite)',
            '蹬伸峰值力发力率': 'Taux de développement de la force en propulsion (RFD)',
            '离心阶段冲量': 'Impulsion excentrique',
            '跌落峰值力到达时间': 'Temps jusqu’à la force de freinage maximale',
            '左侧跌落峰值力到达时间': 'Temps jusqu’à la force de freinage maximale (gauche)',
            '右侧跌落峰值力到达时间': 'Temps jusqu’à la force de freinage maximale (droite)',
            '蹬伸峰值加速度': 'Accélération propulsive maximale',
            '绝对最大力值': 'Force maximale',
            '单位体重最大力值': 'Force maximale relative',
            '左侧最大力值': 'Force maximale (gauche)',
            '右侧最大力值': 'Force maximale (droite)',
            '50ms发力率': 'RFD – 50 ms',
            '100ms发力率': 'RFD – 100 ms',
            '150ms发力率': 'RFD – 150 ms',
            '200ms发力率': 'RFD – 200 ms',
            '250ms发力率': 'RFD – 250 ms',
            '300ms发力率': 'RFD – 300 ms',
            '50ms冲量': 'Impulsion – 50 ms',
            '100ms冲量': 'Impulsion – 100 ms',
            '150ms冲量': 'Impulsion – 150 ms',
            '200ms冲量': 'Impulsion – 200 ms',
            '250ms冲量': 'Impulsion – 250 ms',
            '300ms冲量': 'Impulsion – 300 ms',
            '到达最大力值时间': 'Temps jusqu’à la force maximale',
            '左侧到达最大力值时间': 'Temps jusqu’à la force maximale (gauche)',
            '右侧到达最大力值时间': 'Temps jusqu’à la force maximale (droite)',
            '平均缓冲最大力值': 'Force de freinage maximale moyenne',
            '平均蹬伸最大力值': 'Force propulsive maximale moyenne',
            '平均缓冲最大力值加载率': 'RFD de freinage moyen',
            '平均缓冲时间': 'Durée moyenne de freinage',
            '平均蹬伸时间': 'Durée moyenne de propulsion',
            '平均触地时间': 'Temps moyen jusqu’au décollage',
            '平均腾空时间': 'Temps de vol moyen',
            '平均起跳速度': 'Vitesse moyenne de décollage',
            '平均腾空高度': 'Hauteur moyenne de saut',
            '平均蹬伸功率': 'Puissance propulsive moyenne',
            '平均蹬伸峰值功率': 'Puissance propulsive maximale moyenne',
            '平均下蹲速度': 'Vitesse excentrique moyenne',
            '平均下蹲深度': 'Profondeur moyenne d’abaissement',
            '缓冲最大力值': 'Force de freinage maximale',
            '缓冲最大力值加载率': 'RFD de freinage',
            '蹬伸功率': 'Puissance propulsive',
            '缓冲时间': 'Durée de freinage',
            '下蹲速度': 'Vitesse excentrique',
            '蹲起时间': 'Durée du squat',
            '下蹲和蹬伸时间比': 'Rapport durée excentrique/propulsive',
            '平均击打峰值力': 'Force maximale moyenne de tapotement',
            '平均击打时间': 'Temps de contact moyen',
            '平均撤离时间': 'Temps de vol moyen',
            '频率': 'Fréquence',
            '初段平均频率': 'Fréquence moyenne – phase initiale',
            '中段平均频率': 'Fréquence moyenne – phase intermédiaire',
            '末段平均频率': 'Fréquence moyenne – phase terminale',
            '最小自由频率': 'Fréquence minimale',
            '最大自由频率': 'Fréquence maximale',
            '总计次数': 'Nombre de répétitions',
            '耐力指数': 'Indice d’endurance',
            '疲劳指数': 'Indice de fatigue',
            '落地峰值力': 'Force d’atterrissage maximale',
            '左侧落地峰值力': 'Force d’atterrissage maximale (gauche)',
            '右侧落地峰值力': 'Force d’atterrissage maximale (droite)',
            '落地峰值力加载率': 'RFD à l’atterrissage',
            '左侧落地峰值力加载率': 'RFD à l’atterrissage (gauche)',
            '右侧落地峰值力加载率': 'RFD à l’atterrissage (droite)',
            '落地峰值力到达时间': 'Temps jusqu’à la force d’atterrissage maximale',
            '左侧落地峰值力到达时间': 'Temps jusqu’à la force d’atterrissage maximale (gauche)',
            '右侧落地峰值力到达时间': 'Temps jusqu’à la force d’atterrissage maximale (droite)',
            '落地到恢复稳定时间': 'Temps de stabilisation',
            '触地时间差': 'Différence du temps de contact',
            '左右摇晃速度': 'Vitesse du CoP – médio-latérale',
            '前后摇晃速度': 'Vitesse du CoP – antéro-postérieure',
            '总体摇晃速度': 'Vitesse du CoP',
            '左右晃动幅度': 'Amplitude du CoP – médio-latérale',
            '前后晃动幅度': 'Amplitude du CoP – antéro-postérieure',
            '左右摇晃幅度': 'Amplitude du CoP – médio-latérale',
            '前后摇晃幅度': 'Amplitude du CoP – antéro-postérieure',
            '落地顺序': 'Séquence d’atterrissage',
            '左右平均摇晃速度': 'Vitesse du CoP – médio-latérale',
            '前后平均摇晃速度': 'Vitesse du CoP – antéro-postérieure',
            '总体平均摇晃速度': 'Vitesse moyenne du CoP',
            '左右摇晃轨迹长度': 'Excursion du CoP – médio-latérale',
            '前后摇晃轨迹长度': 'Excursion du CoP – antéro-postérieure',
            '总体摇晃轨迹长度': 'Excursion totale du CoP',
            '左右摇晃最大幅度': 'Amplitude du CoP – médio-latérale',
            '前后摇晃最大幅度': 'Amplitude du CoP – antéro-postérieure',
            '轨迹包络面积': 'Surface d’oscillation du CoP',
            '最大净力值': 'Force maximale',
            '最大力值': 'Force maximale',
            '最小力值': 'Force minimale',
            '平均力': 'Force moyenne',
            '冲量': 'Impulsion',
            '上箱高度Ht': 'Hauteur cible',
            '平均反应力量指数RSI': 'RSI moyen',
            '缓冲最小力值分量': 'Force minimale de décharge - gauche/droite',
            '制动最大力值分量': 'Force freinage maximale - gauche/droite',
            '蹬伸最大力值分量': 'Force propulsive maximale - gauche/droite',
            '落地最大力值分量': 'Force d’atterrissage maximale - gauche/droite',
            '离心制动阶段发力率分量': 'Taux de développement de la force en freinage (RFD) - gauche/droite',
            '制动最大力值发力率分量': 'Taux de développement de la force en propulsion (RFD) - gauche/droite',
            '蹬伸平均功率分量': 'Puissance propulsive moyenne - gauche/droite',
            '蹬伸峰值功率分量': 'Puissance propulsive maximale - gauche/droite',
            '离心制动阶段冲量分量': 'Impulsion de freinage - gauche/droite',
            '向心阶段净冲量分量': 'Impulsion concentrique - gauche/droite',
            '最大蹬伸力发力率分量': 'Taux maximal de développement de la force (RFD) - gauche/droite',
            '跌落峰值力分量': 'Force de freinage maximale - gauche/droite',
            '蹬伸峰值力分量': 'Force propulsive maximale - gauche/droite',
            '跌落峰值力加载率分量': 'Taux de développement de la force en freinage (RFD) - gauche/droite',
            '蹬伸峰值力发力率分量': 'Taux de développement de la force en propulsion (RFD) - gauche/droite',
            '离心阶段冲量分量': 'Impulsion excentrique - gauche/droite',
            '绝对最大力值分量': 'Force maximale - gauche/droite',
            '单位体重最大力值分量': 'Force maximale relative - gauche/droite',
            '50ms发力率分量': 'RFD – 50 ms - gauche/droite',
            '100ms发力率分量': 'RFD – 100 ms - gauche/droite',
            '150ms发力率分量': 'RFD – 150 ms - gauche/droite',
            '200ms发力率分量': 'RFD – 200 ms - gauche/droite',
            '250ms发力率分量': 'RFD – 250 ms - gauche/droite',
            '300ms发力率分量': 'RFD – 300 ms - gauche/droite',
            '50ms冲量分量': 'Impulsion – 50 ms - gauche/droite',
            '100ms冲量分量': 'Impulsion – 100 ms - gauche/droite',
            '150ms冲量分量': 'Impulsion – 150 ms - gauche/droite',
            '200ms冲量分量': 'Impulsion – 200 ms - gauche/droite',
            '250ms冲量分量': 'Impulsion – 250 ms - gauche/droite',
            '300ms冲量分量': 'Impulsion – 300 ms - gauche/droite',
            '平均缓冲最大力值分量': 'Force de freinage maximale moyenne - gauche/droite',
            '平均蹬伸最大力值分量': 'Force propulsive maximale moyenne - gauche/droite',
            '平均缓冲最大力值加载率分量': 'RFD de freinage moyen - gauche/droite',
            '平均蹬伸功率分量': 'Puissance propulsive moyenne - gauche/droite',
            '平均蹬伸峰值功率分量': 'Puissance propulsive maximale moyenne - gauche/droite',
            '缓冲最大力值分量': 'Force de freinage maximale - gauche/droite',
            '平均击打峰值力分量': 'Force maximale moyenne de tapotement - gauche/droite',
            '平均击打时间分量': 'Temps de contact moyen - gauche/droite',
            '平均撤离时间分量': 'Temps de vol moyen - gauche/droite',
            '落地峰值力分量': 'Force d’atterrissage maximale - gauche/droite',
            '落地峰值力加载率分量': 'RFD à l’atterrissage - gauche/droite',
            '最大力值分量': 'Force maximale - gauche/droite',
            '最小力值分量': 'Force minimale - gauche/droite',
            '平均力分量': 'Force moyenne - gauche/droite',
            '冲量分量': 'Impulsion - gauche/droite',
            '动态反弹指数DRI': 'Indice de Rebond Dynamique (DRI)',
            '平均反应力量指数RSImod': 'RSI modifié moyen',
            '': ''
        }
    },
    UserManagement: {
        Label: {
            Member: "Membre",
            Disabled: "Utilisateur désactivé",
            SelectRole: "Sélectionner un rôle",
            SelectGroup: "Sélectionner un groupe de permissions",
            FilterByAccountName: "Filtrer par nom de compte ou nom d'utilisateur",
            BatchOperate: "Traitement en lot",
            CreateAccount: "Ajouter un nouvel utilisateur",
            Enanble: "Réactiver l'utilisateur",
            Disable: "Désactiver l'utilisateur",
            Delete: "Supprimer définitivement",
            Permission: "Autorisation",
            Information: "Modifier les informations",
            Role: "Rôle",
            PermissionGroup: "Groupe de permissions",
            DefaultGroup: "Groupe par défaut",
            Account: "Compte",
            Password: "Mot de passe",
            Name: "Nom",
            ModifyPermission: "Modifier les autorisations de l'utilisateur",
            ModifyAccountInfo: "Modifier les informations du compte",
            Prev: "Page précédente",
            Next: "Page suivante",
            CreateConfirm: "Confirmer la création de l'utilisateur",
        },
        Columns: {
            AvatarAccount: "Avatar/Compte",
            UserName: "Nom",
            CreateTime: "Date de création",
            RolePermission: "Rôle/Autorisation",
            Operate: "Opération",
        },
        Message: {
            LengthNotice: "Veuillez saisir 8 à 16 caractères",
            AccountFillNotice: "Le mot de passe doit être au format d'adresse e-mail",
            ConfirmDisable: "Êtes-vous sûr de vouloir désactiver cet utilisateur ?",
            ConfirmEnable: "Êtes-vous sûr de vouloir réactiver cet utilisateur ?",
            ConfirmDelete: "Êtes-vous sûr de vouloir supprimer définitivement cet utilisateur ?",
            ConfirmPermissionModify: "Êtes-vous sûr de vouloir modifier les autorisations de cet utilisateur ?",
            ConfirmModifyAccountInfo: "Êtes-vous sûr de vouloir sauvegarder les modifications ?",
            PermissionModifySuccess: "Modification des autorisations réussie",
            PWNotice: "Le mot de passe ne peut pas être vide",
            NameNotice: "Le nom ne peut pas être vide",
        }
    },
    Role: {
        0: "Sportifs",
        1: "Entraîneurs",
        63: "Administrateurs",
        127: "Personnel de maintenance",
        255: "Super administrateurs",
        Subject: "Sportifs",
        Coach: "Entraîneur",
        Admin: "Administrateur",
        OM: "Personnel de maintenance",
    },
    Gender: {
        0: "Masculin",
        1: "Féminin",
        2: 'Autre'
    },
    ActionModel: {
        "RecordCount": "Nombre d'enregistrements",
        "ProjectCount": "Nombre de projets",
        "Nordic": "Nordique",
        "Razor": "Rasoir",
        "IsometricContraction_0": "Contraction isométrique 0°",
        "IsometricContraction_30": "Contraction isométrique 30°",
        "IsometricContraction_60": "Contraction isométrique 60°",
        "Irons": "Fer",
        "Woods": "Bois",
        "Wedges": "Wedge",
        "Hybrids": "Hybride",
        "Putter": "Putter",
        "Iron1": "Fer 1",
        "Iron2": "Fer 2",
        "Iron3": "Fer 3",
        "Iron4": "Fer 4",
        "Iron5": "Fer 5",
        "Iron6": "Fer 6",
        "Iron7": "Fer 7",
        "Iron8": "Fer 8",
        "Iron9": "Fer 9",
        "Iron10": "Fer 10",
        "Driver": "Driver",
        "Wood3": "Bois 3",
        "Wood5": "Bois 5",
        "Wood7": "Bois 7",
        "Wood9": "Bois 9",
        "Pitch": "Pitch",
        "Wedge48": "Wedge 48°",
        "Wedge50": "Wedge 50°",
        "Wedge52": "Wedge 52°",
        "Wedge54": "Wedge 54°",
        "Wedge56": "Wedge 56°",
        "Wedge58": "Wedge 58°",
        "Wedge60": "Wedge 60°",
        "Wedge62": "Wedge 62°",
        "Hybrid1": "Hybride 1",
        "Hybrid2": "Hybride 2",
        "Hybrid3": "Hybride 3",
        "Hybrid4": "Hybride 4",
        "Hybrid5": "Hybride 5",
        "Hybrid6": "Hybride 6",
        "Hybrid7": "Hybride 7",
        '1': "Cou",
        '2': "Flexion avant",
        '3': "Extension arrière",
        '4': "Flexion gauche",
        '5': "Flexion droite",
        '6': "Assis",
        '7': "Assis",
        '8': "Assis",
        '9': "Assis",
        '10': "Épaule",
        '11': "Gauche",
        '12': "Droite",
        '13': "Rotation interne",
        '14': "Rotation externe",
        '15': "Adduction",
        '16': "Abduction",
        '17': "Flexion avant",
        '18': "Extension arrière",
        '19': "Test ISO I",
        '20': "Test ISO Y",
        '21': "Test ISO T",
        '22': "Position assise - Flexion coude 90°",
        '23': "Position assise - Flexion coude 90° et abduction épaule 90°",
        '24': "Position debout - Coude 90°",
        '25': "Position debout - Flexion coude 90°, abduction épaule 90° et rotation externe épaule 90°",
        '26': "Position couchée - Flexion coude 90° et abduction épaule 90°",
        '27': "Position couchée - Flexion coude 90°",
        '28': "Position ventrale",
        '29': "Position assise - Flexion coude 90°",
        '30': "Position assise - Flexion coude 90° et abduction épaule 90°",
        '31': "Position debout - Flexion coude 90°",
        '32': "Position debout - Flexion coude 90° et abduction épaule 90°",
        '33': "Position couchée - Flexion coude 90° et abduction épaule 90°",
        '34': "Position couchée - Flexion coude 90°",
        '35': "Position ventrale",
        '36': "Assis",
        '37': "Debout",
        '38': "Assis",
        '39': "Debout",
        '40': "Position latérale",
        '41': "Position assise - Abduction épaule 90°",
        '42': "Debout",
        '43': "Position debout - Flexion coude 90°",
        '44': "Assis",
        '45': "Debout",
        '46': "Position assise - Flexion épaule 90°",
        '47': "Position debout - Flexion épaule 90°",
        '48': "Couché",
        '49': "Couché",
        '50': "Position ventrale",
        '51': "Couché",
        '52': "Position ventrale",
        '53': "Couché",
        '54': "Position ventrale",
        '55': "Tronc",
        '56': "Flexion avant",
        '57': "Flexion gauche",
        '58': "Flexion droite",
        '59': "Assis",
        '60': "Assis",
        '61': "Assis",
        '62': "Hanche",
        '63': "Gauche",
        '64': "Droite",
        '65': "Flexion avant",
        '66': "Extension arrière",
        '67': "Rotation interne",
        '68': "Rotation externe",
        '69': "Adduction",
        '70': "Abduction",
        '71': "Debout",
        '72': "Position ventrale",
        '73': "Position ventrale - Flexion genou 90°",
        '74': "Position semi-ventrale",
        '75': "Debout",
        '76': "Couché",
        '77': "Assis",
        '78': "Assis",
        '79': "Couché",
        '80': "Position ventrale",
        '81': "Assis",
        '82': "Couché",
        '83': "Position ventrale",
        '84': "Couché",
        '85': "Couché - Flexion genou 45°",
        '86': "Couché - Coude 90°",
        '87': "Couché",
        '88': "Couché - Flexion genou 45°",
        '89': "Couché - Coude 90°",
        '90': "Position latérale",
        '91': "Coude",
        '92': "Gauche",
        '93': "Droite",
        '94': "Flexion avant",
        '95': "Extension arrière",
        '96': "Position assise - Flexion coude 90° et poignet neutre",
        '97': "Position assise - Flexion coude 90° et pronation poignet",
        '98': "Position assise - Flexion coude 90° et supination poignet",
        '99': "Position assise - Flexion coude 90°, abduction épaule 90° et poignet neutre",
        '100': "Position assise - Flexion coude 90°, abduction épaule 90° et pronation poignet",
        '101': "Position debout - Flexion coude 90° et poignet neutre",
        '102': "Position assise - Flexion coude 90°",
        '103': "Poignet",
        '104': "Gauche",
        '105': "Droite",
        '106': "Supination",
        '107': "Pronation",
        '108': "Flexion avant",
        '109': "Extension arrière",
        '110': "Déviation ulnaire",
        '111': "Déviation radiale",
        '112': "Flexion coude 90° et poignet neutre",
        '113': "Flexion coude 90° et poignet neutre",
        '114': "Flexion coude 90° et poignet neutre",
        '115': "Flexion coude 90° et poignet neutre",
        '116': "Flexion coude 90° et poignet neutre",
        '117': "Flexion coude 90° et pronation poignet",
        '118': "Flexion coude 90° et supination poignet",
        '119': "Flexion coude 90° et poignet neutre",
        '120': "Flexion coude 90° et pronation poignet",
        '121': "Flexion coude 90° et supination poignet",
        '122': "Main",
        '123': "Gauche",
        '124': "Droite",
        '125': "Force de préhension",
        '126': "Position assise - Flexion coude 90° et poignet neutre",
        '127': "Position assise - Poignet neutre",
        '128': "Position assise - Flexion épaule 90° et poignet neutre",
        '129': "Genou",
        '130': "Gauche",
        '131': "Droite",
        '132': "Flexion",
        '133': "Extension",
        '134': "Assis",
        '135': "Position ventrale",
        '136': "Couché",
        '137': "Position assise - Flexion genou 90°",
        '138': "Position ventrale - Flexion genou 90°",
        '139': "Couché",
        '140': "Cheville",
        '141': "Gauche",
        '142': "Droite",
        '143': "Varus",
        '144': "Valgus",
        '145': "Dorsiflexion",
        '146': "Plantarflexion",
        '147': "Position assise jambes tendues",
        '148': "Position assise jambes tendues",
        '149': "Position assise jambes tendues",
        '150': "Position assise jambes tendues",
        '151': "Pied",
        '152': "Gauche",
        '153': "Droite",
        '154': "Flexion des orteils",
        '155': "Extension des orteils",
        '156': "Assis",
        '157': "Position assise jambes tendues - Plantarflexion",
        '158': "Position assise jambes tendues - Neutralité plantaire",
        '159': "Assis",
        '160': "Position assise jambes tendues - Neutralité plantaire",
        '161': "Position assise jambes tendues - Plantarflexion",
        '162': "Debout",
        '163': "Couché",
        '164': "Debout",
        '165': "Couché",
        '166': "Debout",
        '167': "Couché",
        '168': "Debout",
        '169': "Couché",
        '170': "Position latérale",
        '171': "Position latérale",
        '172': "Élévation des scapulae",
        '173': "Protraction des scapulae",
        '174': "Rétraction des scapulae",
        '175': "Assis",
        '176': "Assis",
        '177': "Assis",
        '178': "Position assise - Flexion coude 90°",
        '179': "Position debout - Flexion coude 90°",
        '180': "Position couchée - Flexion coude 90°",
        '181': "Position assise - Flexion coude 90°",
        '182': "Position debout - Flexion coude 90°",
        '183': "Position ventrale",
        '184': "Position assise - Abduction épaule 90°",
        '185': "Position assise - Abduction épaule 90° et Flexion coude 90°",
        '186': "Position assise - Flexion coude 90°",
        '187': "Position assise - Abduction épaule 90° et Flexion coude 90°",
        '188': "Position debout - Flexion coude 90°",
        '189': "Position latérale - Flexion coude 90°",
        '190': "Position assise - Flexion coude 90°, abduction épaule 90° et rotation externe épaule 90°",
        '191': "Position assise - Flexion coude 90°, abduction épaule 90° et rotation externe épaule 90°",
        '192': "Position latérale - Flexion coude 90°",
        '193': "Position debout - Flexion coude 90° et pronation poignet",
        '194': "Position debout - Flexion coude 90° et supination poignet",
        '195': "Position debout - Flexion coude 90°",
        '197': "Autre",
        '198': "Position debout - Flexion genou 90°",
        '199': "Position assise - Flexion genou 45°",
        '200': "Position semi-couchée",
        '201': "Position ventrale - Flexion genou 45°",
        '205': "Soulevé de terre mi-cuisse",
        '206': "Debout",
        '207': "Flexion coude 90° et supination poignet",
        '208': "Flexion coude 90° et pronation poignet",
        "Hip_Joint": "Articulation de la hanche",
        "Buckling": "Flexion",
        "Stand_Straight": "Position debout jambes tendues",
        "Stand_Knees_Kick": "Position debout - Coup de genou",
        "Stomach_Knees_30": "Position ventrale - Flexion genou 30°",
        "Sit_Knees_90": "Position assise - Flexion genou 90°",
        "Back_Knees_90": "Position couchée - Flexion genou 90°",
        "Spread": "Extension",
        "Stomach_Knees_Thigh": "Position ventrale - Flexion genou 90° - Ischio-jambiers",
        "Stand_Upright_Ankle": "Position debout jambes tendues - Cheville",
        "Adduction_Abduction": "Adduction/Abduction",
        "Back_Knees_120": "Position couchée - Flexion genou 120°",
        "Back_Knees_135": "Position couchée - Flexion genou 135°",
        "Stance_Ankles": "Position debout - Cheville",
        "Standing_Knees": "Position debout - Genou",
        "Back_Ankles": "Position couchée - Cheville",
        "Back_Knees": "Position couchée - Genou",
        "Internal_External": "Rotation interne/externe",
        "Stomach_Knees_90": "Position ventrale - Flexion genou 90°",
        "Knee_Joint": "Articulation du genou",
        "Stomach_Knees_45": "Position ventrale - Flexion genou 45°",
        "Stand_Knees_90": "Position debout - Flexion genou 90°",
        "Back_Knees_45": "Position couchée - Flexion genou 45°",
        "Sit_Knees_10": "Position assise - Flexion genou 10°",
        "Sit_Knees_45": "Position assise - Flexion genou 45°",
        "Back_Knees_10": "Position couchée - Flexion genou 10°",
        "Ankle_Joint": "Articulation de la cheville",
        "Dorsiflexion": "Dorsiflexion",
        "Sitting_Position": "Position assise",
        "Varus_Valgus": "Varus/Valgus",
        "Back_StraightLegs": "Position couchée - Jambes tendues",
        "Toe_Flexion": "Flexion des orteils",
        "Lie_Supine": "Position couchée",
        "Shoulder_Joint": "Articulation de l'épaule",
        "Stomach_Straight": "Position ventrale - Bras tendus",
        "Abduction": "Abduction",
        "Side_Straight": "Position latérale - Bras tendus",
        "Adduction": "Adduction",
        "Shoulder_Elbow": "Position couchée - Abduction épaule 90° et Flexion coude 90°",
        "Elbow_Neutral": "Position couchée - Flexion coude 90° neutre",
        "Articulatio_Cubiti": "Articulation du coude",
        "Sit_Elbows_90": "Position assise - Flexion coude 90°",
        "Neck": "Cou",
        "Default_Position": "Position par défaut",
        "Lateral_Flexion": "Flexion latérale",
        'Other': 'Autre',
        'Upper_Push': 'Poussée du membre supérieur',
        "Default": "Par défaut",
        "Left": "Gauche",
        "Right": "Droite",
        "Left_To_Right": "Gauche puis droite",
        "Right_To_Left": "Droite puis gauche",
        "simultaneously": "Simultanément",
        "Null": "Aucun",
        "CMJ": "Squat-saut",
        "SJ": "Saut depuis l'accroupissement",
        "DropJump": "Saut de chute",
        "MVC": "Contraction musculaire volontaire maximale",
        "RepetitiveHopping": "Sauts de jambes tendues répétés",
        "RepetitiveCMJ": "Sauts de squat répétés",
        "Squat": "Squat",
        "Stamping": "Test de fréquence et d'endurance des mouvements verticaux",
        "Landing": "Test d'atterrissage",
        "Balance": "Test d'équilibre",
        "AthleticShoulder": "Test de l'épaule athlétique",
        "Free": "Test libre",
        "DJ": "Saut en profondeur",
        "Inside": "Intérieur",
        "Outside": "Extérieur",
        "踝关节": "Cheville",
        "肘关节": "Coude",
        "髋关节": "Hanche",
        "颈部": "Cou",
        "肩关节": "Épaule",
        "躯干": "Tronc",
        "膝关节": "Genou",
        "腕关节": "Poignet",
        "腕关节尺偏": "Déviation ulnaire du poignet",
        "髋关节外旋": "Rotation externe de la hanche",
        "髋关节内收": "Adduction de la hanche",
        "髋关节外展": "Abduction de la hanche",
        "颈部屈曲": "Flexion du cou",
        "颈部伸展": "Extension du cou",
        "颈部侧屈": "Flexion latérale du cou",
        "颈部旋转": "Rotation du cou",
        "肩关节内旋": "Rotation interne de l'épaule",
        "肩关节外旋": "Rotation externe de l'épaule",
        "肩关节屈曲": "Flexion de l'épaule",
        "踝内翻": "Varus de la cheville",
        "踝外翻": "Valgus de la cheville",
        "足背屈": "Dorsiflexion du pied",
        "足跖屈": "Plantarflexion du pied",
        "肘伸展": "Extension du coude",
        "肘屈曲": "Flexion du coude",
        "髋关节伸展": "Extension de la hanche",
        "髋关节屈曲": "Flexion de la hanche",
        "髋关节内旋": "Rotation interne de la hanche",
        "肩关节外展": "Abduction de l'épaule",
        "躯干伸展": "Extension du tronc",
        "躯干侧屈": "Flexion latérale du tronc",
        "膝关节屈曲": "Flexion du genou",
        "膝关节伸展": "Extension du genou",
        "腕关节桡偏": "Déviation radiale du poignet",
        "肩关节水平内收": "Adduction horizontale de l'épaule",
        "肩关节水平外展": "Abduction horizontale de l'épaule",
        "肩关节伸展": "Extension de l'épaule",
        "躯干屈曲": "Flexion du tronc",
        "躯干旋转": "Rotation du tronc",
        "腕关节旋前": "Pronation du poignet",
        "肩关节内收": "Adduction de l'épaule",
        "腕关节旋后": "Supination du poignet",
        "腕关节屈曲": "Flexion du poignet",
        "腕关节伸展": "Extension du poignet",
        "仰卧位": "Position couchée",
        "仰卧位（直腿）": "Position couchée (jambes tendues)",
        "仰卧位（肘屈曲 90°）": "Position couchée (flexion coude 90°)",
        "仰卧位（肩外展 90° - 肘屈曲 90°）": "Position couchée (abduction épaule 90° - flexion coude 90°)",
        "侧卧位": "Position latérale",
        "俯卧位": "Position ventrale",
        "俯卧位（肩外展 90° - 肘屈曲 90°）": "Position ventrale (abduction épaule 90° - flexion coude 90°)",
        "半跪姿": "Position à genoux",
        "坐位": "Position assise",
        "坐位（肘屈曲 90°）": "Position assise (flexion coude 90°)",
        "坐位（肩外展 90° - 肘屈曲 90°）": "Position assise (abduction épaule 90° - flexion coude 90°)",
        "站立位": "Position debout",
        "站立位（肘屈曲 90°）": "Position debout (flexion coude 90°)",
        "站立位（肩外展 90° - 肘屈曲 90°）": "Position debout (abduction épaule 90° - flexion coude 90°)",
        "肘屈曲90°": "Flexion coude 90°",
        "长坐位（无跖屈）": "Position assise jambes tendues (sans plantarflexion)",
        "长坐位（跖屈）": "Position assise jambes tendues (avec plantarflexion)",
        "动作模块": "Module d'action",
        Wrist: "Poignet",
        Flexion: "Flexion",
        Extension: "Extension",
        Supination: "Supination",
        Pronation: "Pronation",
        Ulnar_Deviation: "Déviation ulnaire",
        Radial_Deviation: "Déviation radiale",
        Wrist_Neutral: "Poignet neutre (coude 90°)",
        Wrist_Supination: "Supination du poignet (coude 90°)",
        Wrist_Pronation: "Pronation du poignet (coude 90°)"
    },
    StandardData: {
        "Title": "Gestion des valeurs standard (Force musculaire portable)",
        "Assembly": "Combinaison de mouvements",
        "Limbs": "Tronc",
        "Actions": "Mouvements",
        "Pose": "Posture",
        "Gender": "Sexe",
        "Age": "Âge",
        "PeakForce": "Force de crête (N/kg)",
        "Modify": "Définir les valeurs standard",
        "FileBrowsing": "Exploration de fichiers",
        "FileRequired": "Veuillez sélectionner le fichier à importer",
        "DropFileHere": "Déposez le fichier ici",
        "clickToUpload": "Télécharger en cliquant",
        "SportTitle": "Gestion des valeurs standard (Performance fonctionnelle sportive)",
        "Mean": "Moyenne",
        "Outstanding": "Valeurs excellentes",
        "青少年": "Adolescents",
        "18~30": "18-30",
        "31~45": "31-45",
        "46~60": "46-60",
        "AgeGroup": "Groupe d'âge",
        "ModifySuccess": "Modification réussie",
        "ErrorRaw": "Ligne d'erreur",
        "ErrorInfo": "Informations sur l'erreur",
        "ErrorCount": "Nombre d'erreurs",
        "Sure": "Confirmer",
        "ErrorStatistics": "Statistiques des erreurs",
        "EmptyId": "L'ID ne peut pas être vide",
        "IdParseError": "ID invalide",
        "EmptyValue": "La valeur standard ne peut pas être vide",
        "InvalidId": "ID invalide",
        "ValueParseError": "Valeur standard invalide",
    },
    Project: {
        "Public": "Publique",
        "Private": "Privé",
        "Title": "Titre du test",
        "FilterName": "Filtrer par nom de projet",
        "FilterSubject": "Filtrer par nom de sujet",
        Columns: {
            "CreateTime": "Date de création",
            "ProjectName": "Nom du projet",
            "CreatorName": "Nom du créateur",
            "Operate": "Actions",
            "Name": "Nom",
            "Gender": "Sexe",
            "Age": "Âge",
            "SubjectName": "Nom du sujet",
            "Model": "Action de test",
        },
        "RecordView": "Enregistrements",
        "Batch": "Opérations en masse",
        "BatchDelete": "Suppression en masse",
        "DeleteEmptyNotice": "Veuillez sélectionner le contenu à supprimer",
        "Finish": "Terminer",
        "Create": "Créer un projet de test",
        "View": "Projet de test",
        "ProjectName": "Nom du projet",
        "Subjects": "Sujets",
        "AddSubject": "Ajouter un sujet",
        "PublicProject": "Projet public",
        "PrivateProject": "Projet privé",
        "ProjectType": "Type de projet",
        "CreateTime": "Date de création",
        "CreateProject": "Créer un projet",
        "Save": "Enregistrer les modifications",
        "ProjectSubjectList": "Liste des sujets du projet",
        "NameFilter": "Filtrer par nom",
        "CreateSuccess": "Création réussie",
        "ModifySuccess": "Modification réussie",
        "DeleteSuccess": "Suppression réussie",
        "DeleteFailed": "Échec de la suppression",
        "NameTooLong": "Le nom est trop long, veuillez ne pas dépasser 24 caractères",
        "RequireName": "Veuillez entrer le nom du projet",
        "SubjectManagerment": "Gestion des sujets",
        "Added": "Ajouté",
        "DeleteConfirm": "Supprimer le projet supprimera également les enregistrements de test associés. Confirmez-vous de continuer ?",
        "ConfirmToDeleteRow": "Confirmez-vous de supprimer cette ligne ?",
        "ConfromToDeleteSubjetc": "Supprimer le sujet supprimera également les enregistrements de test associés. Confirmez-vous de continuer ?",
        "DoNotAskAgain": "Ne plus afficher ce message",
    },
    TrainingPlan: {
        Title: "Plan d'entraînement",
        PlanType: "Type",
        Public: "Publique",
        Private: "Privé",
        PlanName: "Nom du plan",
        Columns: {
            CreateTime: "Date de création",
            PlanName: "Nom du plan",
            CreatorName: "Nom du créateur",
            Operate: "Actions",
            ActionCount: "Nombre d'actions",
            Seq: "Numéro",
            Action: "Action",
            ActionTimes: "Nombre de répétitions",
            SubjectName: "Nom du sujet",
            Completeness: "Taux de complétion",
            UsedTimes: "Nombre de tests",
            Model: "Action de test",
            Gender: "Sexe",
        },
        "Skipped": "Ignoré",
        "RecordView": "Enregistrements",
        "Batch": "Opérations en masse",
        "BatchDelete": "Suppression en masse",
        "Finish": "Terminer",
        "Create": "Créer un plan d'entraînement",
        "Modify": "Modifier",
        "Actions": "Actions",
        "Subjects": "Sujets",
        "Records": "Enregistrements de test",
        "Statue": "Statut d'achèvement",
        "Finished": "Achevé",
        "Unfinish": "Inachevé",
        "FilterName": "Filtrer par nom de plan",
        "RequireName": "Veuillez entrer le nom du plan",
        "NameTooLong": "Le nom est trop long, veuillez ne pas dépasser 50 caractères",
        "deleteRecord": "Supprimer l'enregistrement",
        "DeleteConfirm": "L'opération supprimera également les enregistrements de test associés. Confirmez-vous de continuer ?",
        "AddAction": "Ajouter une action",
        "TestActions": "Actions de test",
        "CreatePlan": "Créer un plan d'entraînement",
        "SavePlan": "Enregistrer le plan d'entraînement",
        "Action": "Action",
        "Times": "Nombre de répétitions",
        "ActionAssembly": "Combinaison d'actions",
        "RequireAssembly": "Veuillez sélectionner des actions",
        "ConfirmDeleteAction": "Confirmez-vous de supprimer cette action ?",
    },
    //运动表现标记信息
    "动作开始": "Début du mouvement",
    "峰值": "Pic",
    "离地": "Décollage",
    "落地": "Atterrissage",
    "开始": "Début",
    "制动": "Freinage",
    "最低点": "Point bas",
    "落地峰值": "Pic d'atterrissage",
    "动作结束": "Fin du mouvement",
    "跌落峰值": "Pic de chute",
    "蹬伸峰值": "Pic d'extension",
    "左侧最大力值": "Force maximale gauche",
    "右侧最大力值": "Force maximale droite",
    "50ms": "50 ms",
    "100ms": "100 ms",
    "150ms": "150 ms",
    "200ms": "200 ms",
    "250ms": "250 ms",
    "300ms": "300 ms",
    "TFmin": "TFmin",
    "T1": "T1",
    "TStart": "TStart",
    "TEnd": "TEnd",
    "PO": "PO",
    "触地": "Contact avec le sol",
    "稳定": "Stabilité",
    "最大垂直力值": "Force verticale maximale",
    "A": "A",
    "B": "B",
    "C": "C",
    "D": "D",
    "E": "E",
    "制动时刻": "Moment de freinage",
    "起跳时刻": "Moment de saut",
    "蹬伸": "Extension",
    "结束": "Fin",
    //错误信息
    DefaultGroup: "Groupe par défaut",
    Empty_PhoneNumber: "Veuillez entrer le numéro de téléphone",
    Duplicate_PhoneNumber: "Le numéro de téléphone est déjà utilisé, impossible de le lier à nouveau",
    Invalid_BOMType: "Le type de module n'existe pas !",
    InsertFailed_Assembly: "Échec de l'ajout d'action !",
    Invalid_BOM: "Le module n'existe pas !",
    InsertFailed_BOM: "Échec de l'ajout du module !",
    UpdateFailed_BOM: "Échec de la mise à jour du module !",
    DeleteFailed_BOM: "Échec de la suppression du module !",
    Invalid_Project: "Le projet n'existe pas !",
    Invalid_Subject: "Le sujet n'existe pas !",
    Exsist_Account: "Le compte existe déjà !",
    Invalid_Account: "Le compte n'existe pas !",
    Incorrect_OldPassword: "L'ancien mot de passe est incorrect !",
    Invalid_Company: "L'entreprise n'a pas été trouvée !",
    Invalid_CompanyID: "Le code de l'entreprise est invalide !",
    Incorrect_ApplicationCode: "Le code de l'application est invalide !",
    Incorrect_AccountOrPassword: "Nom d'utilisateur ou mot de passe incorrect !",
    Expired_Captcha: "Le code de vérification a expiré !",
    Incorrect_Captcha: "Le code de vérification est incorrect !",
    Failed_SendCaptcha: "L'envoi du code de vérification a échoué !",
    Invalid_Captcha: "Le code de vérification est invalide !",
    Empty_SubjectName: "Veuillez entrer le nom du sujet !",
    Repeat_SubjectName: "Un sujet avec le même nom existe déjà !",
    Duplicate_Requests: "Les requêtes sont trop fréquentes, veuillez réessayer plus tard",
    UnknownError_Account: "L'utilisateur actuel n'existe pas !",
    Locked_Company: "L'organisation/entreprise est verrouillée !",
    Expired_Authorization: "L'autorisation de l'application de l'organisation/entreprise a expiré !",
    Invalid_Authorization: "L'autorisation de l'application de l'organisation/entreprise n'est pas activée !",
    Invalid_Parameter: "Paramètre invalide !",
    Invalid_License: "La licence est invalide !",
    Binded_License: "La licence est déjà liée à un autre appareil !",
    Unbind_License: "La licence n'est pas encore liée !",
    Expired_License: "La licence a expiré !",
    Failed_License: "La vérification de la licence a échoué !",
    Empty_ApplictionCode: "Le code de l'application est manquant !",
    Invalid_ApplictionCode: "Le code de l'application est invalide !",
    Invalid_ApplictionEndPoint: "Nœud système invalide",
    Older_Version: "Version plus ancienne",
    Empty_Version: "Aucune version valide",
    Duplicate_ApplicationCode: "Code d'identification système dupliqué",
    Invalid_Application: "Application de test invalide",
    Empty_Upgrade: "Veuillez sélectionner le fichier à mettre à jour",
    Invalid_Version: "Version invalide",
    Invalid_Record: "Enregistrement invalide",
    NotFound_Record: "Enregistrement de données introuvable",
    Failed_ResetPassword: "Échec de la réinitialisation du mot de passe",
    Incomplete_Infomation: "Informations incomplètes",
    Invalid_Binded: "Enregistrement de liaison invalide",
    ParallelLimit_License: "Dépassement du nombre maximum de liaisons",
    Exsist_PermissionGroup: "Groupe de permissions déjà existant",
    Invalid_PermissionDenied: "Permissions insuffisantes",
    Invalid_PermissionGroup: "Permissions de rôle invalides",
    Duplicate_Project: "Projet de test dupliqué",
    Duplicate_SportProject: "Le nom du projet sportif ne peut pas être dupliqué",
    Invalid_SportProject: "Projet sportif invalide",
    Invalid_File: "Fichier inexistant !",
    UploadFailed_NoFile: "Aucun fichier à télécharger !",
    DownloadFailed_NoFile: "Fichier non trouvé !",
    Incorrect_Format: "Format de données incorrect",
    UploadFailed_Timeout: "Délai d'attente dépassé lors du téléchargement !",
    DownloadFailed_Timeout: "Délai d'attente dépassé pour le téléchargement !",
    Repeat_Name: "Utilisateur avec le même nom déjà existant",
    Empty_Account: "Veuillez entrer le compte",
    Empty_Password: "Veuillez entrer le mot de passe",
    Empty_Name: "Veuillez entrer le nom",
    Invationing_SubjectEmail: "L'e-mail du sujet est en cours d'invitation",
    Invationing_SubjectName: "Le nom de l'athlète est en cours d'invitation",
    Invalid_InvationLink: "Lien invalide",
    Submit_SubjectInfo: "Informations de l'athlète soumises",
    Incorrect_Subject: "Athlète inexistant",
    Incomplete_InvationCode: "Code d'invitation manquant",
    Duplicate_Subject: "Nom d'athlète déjà existant",
    Duplicate_InvationEmail: "Impossible d'envoyer une invitation au même e-mail dans les cinq minutes",
    Invalid_RecordSide: "Ordre invalide",
    NotBe_SameDay: "Les dates sélectionnées doivent être le même jour",
    Invalid_Indicator: "Indicateur invalide",
    Invalid_UserName: "Le pseudonyme de l'utilisateur ne peut pas être vide",
    UnUpload_SubjectOrProject: "Tests ou athlètes non téléchargés",
    UnUpload_Subject: "Athlète non téléchargé",
    Duplicate_SubjectName: "Nom du sujet dupliqué",
    SyncData: "Veuillez d'abord extraire les données",
    Duplicate_TrainingPlanName: "Nom de plan d'entraînement dupliqué",
    Invalid_TrainingPlan: "Plan d'entraînement invalide",
    Invalid_Key: "Clé invalide",
    Failed_CallService: "Échec de l'appel au service",
    FileNotExist: "Fichier inexistant",
    Repeat_ProjectName: "Nom de projet dupliqué",
}